import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
const KENTUCKY_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/d63c4c5d-0549-4f31-906b-ac6bbc2a5ab9.jpg';
const cities = ['Louisville', 'Lexington', 'Bowling Green', 'Frankfort', 'Elizabethtown', 'Owensboro', 'Crestwood', 'Shelbyville'];

/** Simplified Kentucky silhouette used as a subtle background graphic. */
const KENTUCKY_PATH = 'M6 46 L18 40 L30 44 L44 38 L58 42 L74 34 L96 30 L120 26 L150 22 L182 20 L214 22 L246 20 L268 24 L286 30 L292 40 L286 52 L272 58 L258 56 L240 62 L214 66 L188 64 L160 70 L132 74 L104 72 L78 78 L56 74 L40 66 L26 60 L12 56 Z';
export function Kentucky() {
  return <section className="relative isolate overflow-hidden bg-ink-900 py-24 sm:py-32" data-id="element-207" data-mp="1kg2pl7zfgktb">
      <img src={KENTUCKY_BG} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-25" data-id="element-208" data-mp="30u2ku5nbvma8" />
      <div className="absolute inset-0 -z-10 bg-ink-900/70" aria-hidden="true" data-id="element-209" data-mp="vqmz0mhf7h9e" />

      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-210" data-mp="10pq1bz60n9do">
        <Reveal data-id="element-211" data-mp="15qxcm87daqp3">
          <div data-id="element-212" data-mp="15q45h64hxz6f">
            <Eyebrow tone="light" data-id="element-213" data-mp="15nht8t6nuvhv">Kentucky Owned &amp; Operated</Eyebrow>
            <h2 className="mt-6 font-display text-[clamp(2.1rem,5vw,3.8rem)] leading-[1.02] tracking-[-0.02em] text-white" data-id="element-214" data-mp="19qnxxwe4kem8">
              Proudly Improving
              <span className="block italic text-brass-light" data-id="element-215" data-mp="hzrutnhv9oc5">Kentucky Homes.</span>
            </h2>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-white/70" data-id="element-216" data-mp="m13e7ba5ddbw">
              From fresh paint to complete renovations, Unbelievable Remodeling &amp;
              Painting helps Kentucky homeowners create spaces they&rsquo;re proud to
              call home.
            </p>
            <ul className="mt-9 flex flex-wrap gap-2" data-id="element-217" data-mp="3uh6nflgwra2c">
              {cities.map(city => <li key={city} className="rounded-full border border-white/15 px-4 py-2 text-[12px] tracking-wide text-white/65" data-id="element-218" data-mp="11mojskjudpa3">
                  {city}
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.14} data-id="element-219" data-mp="16doedj5hnv9f">
          <div className="relative flex items-center justify-center" data-id="element-220" data-mp="16deri4fqq47y">
            <svg viewBox="0 0 300 100" role="img" aria-label="Stylized outline of the state of Kentucky" className="w-full max-w-xl" data-id="element-221" data-mp="inu51bkdootx">
              <motion.path d={KENTUCKY_PATH} fill="rgba(192,149,79,0.07)" stroke="#C0954F" strokeWidth="1" strokeLinejoin="round" initial={{
              pathLength: 0,
              opacity: 0
            }} whileInView={{
              pathLength: 1,
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.5
            }} transition={{
              duration: 2,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-222" data-mp="roilse15p3ai" />
              {[{
              cx: 70,
              cy: 52
            }, {
              cx: 138,
              cy: 44
            }, {
              cx: 196,
              cy: 42
            }, {
              cx: 248,
              cy: 40
            }].map((dot, i) => <motion.circle key={`${dot.cx}-${dot.cy}`} cx={dot.cx} cy={dot.cy} r="2.5" fill="#D9B981" initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.5
            }} transition={{
              delay: 1 + i * 0.15,
              duration: 0.4
            }} data-id="element-223" data-mp="1wprx9qsumtvb" data-mpi={i} />)}
            </svg>
          </div>
        </Reveal>
      </div>
    </section>;
}